import translate from "translate";

translate.engine = "google";

const STORAGE_KEY = "cms_translation_cache";

const LOCALE_TO_ISO = {
  en_us: "en", en_gb: "en",
  fr_fr: "fr", de_de: "de", es_es: "es",
  it_it: "it", pt_pt: "pt", zh_cn: "zh", ja_jp: "ja",
};

function loadFromStorage() {
  try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {}; }
  catch { return {}; }
}

function persistToStorage(cache) {
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(cache)); }
  catch { /* storage quota exceeded — silently skip */ }
}

const isEnglish = (locale) => LOCALE_TO_ISO[locale] === "en";

const memoryCache = loadFromStorage();
const inFlight = new Map();

export function translateSync(text, locale) {
  if (!text || isEnglish(locale)) return text;
  return memoryCache[`${locale}::${text}`] ?? text;
}

export async function translateAsync(text, locale) {
  if (!text || isEnglish(locale)) return text;

  const key = `${locale}::${text}`;
  if (memoryCache[key]) return memoryCache[key];
  if (inFlight.has(key)) return inFlight.get(key);

  const promise = translate(text, { from: "en", to: LOCALE_TO_ISO[locale] })
    .then((result) => {
      memoryCache[key] = result;
      persistToStorage(memoryCache);
      inFlight.delete(key);
      return result;
    })
    .catch(() => {
      inFlight.delete(key);
      return text;
    });

  inFlight.set(key, promise);
  return promise;
}
